export default {
  title: 'Estimator24 — сервис оценки недвижимости',
  description: 'Точный анализ цен, ИИ-оценка и прогноз динамики рынка',
  login: 'Войти в личный кабинет'
}
